<template>
  <div @click="handleImageClick(data)">
    <encoded-image
      :image-id="data.id"
      :case-id="examinationId"
      width="200"
      :uri="data.uri"
      style-class="lightbox-thumbnail"
      @on-receive-encoded-image="onEncodedImageLoaded"
    />
    <portal to="lightbox-container">
      <Lightbox
        v-if="activeImage"
        v-model:activeImage="activeImage"
        :images="lightboxImages"
        @close-event="handleClose"
      />
    </portal>
  </div>
</template>

<script>
import Lightbox from "../../../../Layout/Lightbox.vue";
import EncodedImage from "../../../AddOns/EncodedImage.vue";

export default {
  name: "CustomMedia",
  components: { Lightbox, EncodedImage },
  props: {
    title: String,
    data: Object,
    examinationId: Number,
  },
  data() {
    return {
      encodedImages: {},
      activeImage: false,
    };
  },
  computed: {
    lightboxImages() {
      return Object.entries(this.encodedImages).map(([id, url]) => ({
        id,
        url,
      }));
    },
  },
  methods: {
    handleImageClick(image) {
      this.activeImage = this.activeImage
        ? false
        : this.lightboxImages.find((img) => parseInt(img.id) === image.id);
    },
    handleClose() {
      this.activeImage = false;
    },
    onEncodedImageLoaded: function (event) {
      this.encodedImages = {
        ...this.encodedImages,
        [event.imageId]: event.uri,
      };
    },
  },
};
</script>
